import Button from '@cloudscape-design/components/button'
import Spinner from '@cloudscape-design/components/spinner'
import { DashboardInsights } from '../../../lib/types'
import AIAnnotation from './AIAnnotation'

interface Props {
  insights: DashboardInsights | null
  loading: boolean
  refreshing: boolean
  onRefresh: () => void
}

function timeAgo(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m ago`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  return `${Math.floor(diffHours / 24)}d ago`
}

export default function AIInsightsSummaryWidget({ insights, loading, refreshing, onRefresh }: Props) {
  return (
    <div
      style={{
        background: 'var(--color-background-container-content)',
        border: '1px solid var(--color-border-divider-default)',
        borderRadius: 8,
        padding: '14px 18px',
        marginBottom: 16,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>✦ AI Insights</span>
          {insights && (
            <span style={{ fontSize: 11, color: 'var(--color-text-body-secondary, #64748b)' }}>
              Updated {timeAgo(insights.generatedAt)}
            </span>
          )}
        </div>
        <Button
          variant="inline-icon"
          iconName="refresh"
          onClick={() => onRefresh()}
          disabled={refreshing || loading}
          loading={refreshing}
          ariaLabel="Refresh insights"
        >
          Refresh
        </Button>
      </div>

      {(loading || (!insights && !loading)) && (
        <div style={{ color: 'var(--color-text-body-secondary, #64748b)', fontSize: 13 }}>
          {loading ? <Spinner /> : 'Generating your first insights…'}
        </div>
      )}

      {insights && (
        <AIAnnotation bullets={insights.summary} />
      )}
    </div>
  )
}
